import {inject, injectable} from 'inversify';

import type {MembershipExpandCommonFields} from '../../../../api/membership';
import type {Expand} from '../../../../api/types';

import {membershipExpandCommon} from '../../../../api/membership';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class MembershipExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnv(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = membershipExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace MembershipExpandJrpc {
  export type ExpandedFields = MembershipExpandCommonFields;
}
